import { render } from "./CarouselBanner.vue?vue&type=template&id=bb43d1e2"
import script from "./CarouselBanner.vue?vue&type=script&lang=js"
export * from "./CarouselBanner.vue?vue&type=script&lang=js"

import "./CarouselBanner.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__